window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');
    require('jquery-ui/ui/widgets/sortable');
    require('jquery-ui/ui/disable-selection');
    require('select2');
    window.moment = require('moment');
    window.numeral = require('numeral');
    window.underscore = require('underscore');

    numeral.register('locale', 'it', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
    })
    numeral.locale('it');

} catch (e) {

}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.BASE_URL = `${location.protocol}//${location.host}`;

window.axios = require('axios');

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.CSRF_TOKEN = token.content;
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.httpRequest = axios.create({
    baseURL: `${location.protocol}//${location.host}`,
    timeout: 30e3,
    headers: {
        'content-type': 'application/json',
    }
});
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
